import React, { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import FormImageSelect from '../FormImageSelect';
import { ObjectId } from 'bson';
import Input from '../UI/Input';
import Button from '../UI/Button';

export interface TokenStats {
    image: string,
    _id: ObjectId,
    width: number,
    height: number,
    borderColor: string,
    effects: {
        name: string
    }[],
    stats: {
        name:string
        description: string,
        skills: {
            [k:string]: number
        },
        savingThrows: {
            [k:string]: number
        },
        abilities: {
            strength: number,
            dexterity: number,
            constitution: number,
            intelligence: number,
            wisdom: number,
            charisma: number,
        },
        actions: {
            name: string,
            description: string,
        }[],
        counters: {
            name: string,
            max: number,
            value: number,
        }[],
    },
    assignedUsers: string[]
}

// Create a version of TokenStats where _id is optional
export type TokenStatsWithoutId = Omit<TokenStats, '_id'> & { _id?: ObjectId };


interface TokenFormProps {
    externalData: TokenStatsWithoutId,
    onSubmit: (data:TokenStatsWithoutId) => void,

}

const TokenForm = ({ externalData, onSubmit }: TokenFormProps) => {
    const {
        register,
        handleSubmit,
        control,
        reset,
        ...methods
    } = useForm<TokenStatsWithoutId>({ defaultValues: externalData });

    useEffect(() => {
        reset(externalData);
    }, [externalData]);
    return (
        <div className='grow'>
            <FormProvider
                register={register}
                handleSubmit={handleSubmit}
                control={control}
                reset={reset}
                {...methods}
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <label htmlFor="image">Image</label>
                    <FormImageSelect
                        name="image"
                        rules={{ required: true }}
                        type="token"
                    />
                    <label htmlFor="name">Name</label>
                    <Input className='block' {...register('stats.name', { required: true})} />
                    {methods.formState.errors.stats?.name
                        && <span>{methods.formState.errors.stats?.name.message}</span>}
                    <label htmlFor="description">Description</label>
                    <Input className='block' {...register('stats.description', { maxLength: 500 })} />
                    <Button
                        className='mt-3'
                        type="submit"
                    >
                        Submit
                    </Button>
                </form>
            </FormProvider>
        </div>
    );
};
export default TokenForm;
